import React from 'react';

export const RecercatHeader = () => {
  return (
    <header className="Header recercat">
      <img src="img/recercat_header.png" alt="Logo" className="Header_logo" />
    </header>
  );
};
